import type { SanityRefDeconstructed } from '~/sanity'
import { getGlobal } from './data'

interface GetLink {
  linkType?: string
  linkReference?: SanityRefDeconstructed
  linkSlug?: string
  linkExternal?: string
}

export const getLinkType = ({
  linkType,
  linkReference,
  linkSlug,
  linkExternal,
}: GetLink = {}) => {
  if (!linkType) return ''

  const { env } = getGlobal()

  return linkType == 'linkExternal' && linkExternal
    ? linkExternal
    : linkType == 'linkReference' && linkReference?.slug?.current
      ? (env.SITE_URL ?? '') + '/' + linkReference?.slug?.current
      : linkType == 'linkSlug' && linkSlug
        ? linkSlug
        : ''
}

export const getExcerpt = (string: string, maxLength: number) => {
  return string.length > maxLength
    ? string.substring(0, maxLength) + '...'
    : string
}
